import { useParams } from "react-router";
import { IngredientForm } from "./IngredientForm";
import { useIngredientContext } from "../IngredientDetails/useIngredientContext";
import { Forbiddenpage } from "src/components/PageState/ForbiddenPage";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";
import { IngredientCreationV2 } from "./v2/IngredientCreationV2";

export const UpdateQuestionnaire = () => {
    const { startingPageId } = useParams();
    const { ingredient } = useIngredientContext();
    const isProductUxV2 = useIsProductUxV2();

    if (ingredient === undefined) {
        // Should display an Error screen
        // It means the ID is wrong
        return null;
    }

    if (ingredient.canModify === false) {
        return <Forbiddenpage />;
    }

    if (isProductUxV2) {
        return <IngredientCreationV2 existingIngredient={ingredient} />;
    }

    return <IngredientForm existingIngredient={ingredient} startingPageId={startingPageId ?? "0"} />;
};
